import join from 'url-join';

import { createAction, asyncAction, http } from '../util';

import { enableModal } from '../components/modal/actions';

import {
  REPORT_TYPE_ORDER,
  REPORT_TYPE_RETURN,
  REPORT_TYPE_GRIDWALL,
  REPORT_TYPE_TRANSACTIONS,
  REPORT_TYPE_CART
} from './constants';

const { VITE_REPORTS_URL: reportsUrlPrefix, VITE_API2_URL: api2Url } = import.meta.env;
const reportsUrl = join(reportsUrlPrefix, 'v1');

const getReportPath = (type, data) => {
  switch (type) {
    case REPORT_TYPE_ORDER:
      return `/order/${data.orderId}?departmentName=${data.departmentName}${
        data.options && data.options.length > 0 ? `&fields=${data.options.join(',')}` : ''
      }`;

    case REPORT_TYPE_RETURN:
      return `/returns/${data.returnId}?departmentName=${data.departmentName}${
        data.options && data.options.length > 0 ? `&fields=${data.options.join(',')}` : ''
      }`;

    case REPORT_TYPE_GRIDWALL:
      return `/product/search/export${data.productRequest}`;

    case REPORT_TYPE_TRANSACTIONS:
      return '/transactions/history/export';

    case REPORT_TYPE_CART:
      return `/cart/export/${data.cartId}?departmentName=${data.departmentName}${
        data.options && data.options.length > 0 ? `&fields=${data.options.join(',')}` : ''
      }`;

    default:
      return '';
  }
};

export const generateReport = asyncAction({
  baseName: 'GENERATE_REPORT',
  action: action => ({ type, data }) => dispatch => {
    dispatch(action.start(data));
    const getReportHttpMethod = type => {
      switch (type) {
        case REPORT_TYPE_ORDER:
        case REPORT_TYPE_GRIDWALL:
        case REPORT_TYPE_CART:
          return http.get(join(reportsUrl, getReportPath(type, data)));
        case REPORT_TYPE_RETURN:
          return http.post(join(api2Url, '/v1/reports/generateReturnReport'), {
            returnId: data.returnId,
            includeImages: data.includeImages,
            includeUPC: data.includeUPC,
            includeSizes: data.includeSizes
          });
        default:
          return http.post(join(reportsUrl, getReportPath(type, data)), data);
      }
    };
    return getReportHttpMethod(type)
      .then(({ data: response }) => dispatch(action.success(response)))
      .catch(error => {
        dispatch(enableModal());
        dispatch(action.error({ error }));
      });
  }
});

export const requestReportStatus = asyncAction({
  baseName: 'REQUEST_REPORT_STATUS',
  action: action => exportId => dispatch => {
    dispatch(action.start(exportId));
    return http
      .get(join(reportsUrl, `/transactions/history/status/${exportId}`))
      .then(({ data: response }) => dispatch(action.success(response)))
      .catch(error => dispatch(action.error({ error })));
  }
});

export const requestReportStatusV2 = asyncAction({
  baseName: 'REQUEST_REPORT_STATUS_V2',
  action: action => exportId => dispatch => {
    dispatch(action.start(exportId));
    return http
      .get(join(api2Url, `/v1/reports/status/${exportId}`))
      .then(({ data: response }) => dispatch(action.success(response)))
      .catch(error => dispatch(action.error({ error })));
  }
});

export const downloadReport = asyncAction({
  baseName: 'DOWNLOAD_REPORT',
  action: action => exportId => dispatch => {
    const headers = { accept: 'application/octet-stream' };
    dispatch(action.start(exportId));
    return http
      .get(join(reportsUrl, `/report/download/${exportId}`), headers)
      .then(response => dispatch(action.success(response)))
      .catch(error => dispatch(action.error({ error })));
  }
});

export const setStatus = createAction('SET_DOWNLOAD_STATUS');
export const setType = createAction('SET_DOWNLOAD_TYPE');

export const toggleBanner = createAction('TOGGLE_DOWNLOAD_BANNER');

export const addDownloadOption = createAction('ADD_DOWNLOAD_OPTION');
export const removeDownloadOption = createAction('REMOVE_DOWNLOAD_OPTION');
export const updateSelectOption = createAction('UPDATE_SELECT_OPTION');
